 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import BUNDLE_COVER from '@/components/bundle_cover'
 import BUNDLE_TITLE from '@/components/bundle_title'
 import BUNDLE_CONTENT from '@/components/bundle_content'
 import BOOK1COVER from '@/components/Book1/cover'
 import BOOK1WIZARDINOZ2 from '@/components/Book1/WizardinOz2'
 import BOOK1EPIGRAPH from '@/components/Book1/Epigraph'
 import BOOK1WIZARDINOZ3 from '@/components/Book1/WizardinOz3'
 import BOOK1WIZARDINOZ4 from '@/components/Book1/WizardinOz4'
 import BOOK1WIZARDINOZ5 from '@/components/Book1/WizardinOz5'
 import BOOK1WIZARDINOZ6 from '@/components/Book1/WizardinOz6'
 import BOOK1WIZARDINOZ7 from '@/components/Book1/WizardinOz7'
 import BOOK1WIZARDINOZ8 from '@/components/Book1/WizardinOz8'
 import BOOK1WIZARDINOZ9 from '@/components/Book1/WizardinOz9'
 import BOOK1WIZARDINOZ10 from '@/components/Book1/WizardinOz10'
 import BOOK1WIZARDINOZ11 from '@/components/Book1/WizardinOz11'
 import BOOK1WIZARDINOZ12 from '@/components/Book1/WizardinOz12'
 import BOOK1WIZARDINOZ13 from '@/components/Book1/WizardinOz13'
 import BOOK1WIZARDINOZ14 from '@/components/Book1/WizardinOz14'
 import BOOK1WIZARDINOZ15 from '@/components/Book1/WizardinOz15'
 import BOOK1WIZARDINOZ16 from '@/components/Book1/WizardinOz16'
 import BOOK1WIZARDINOZ17 from '@/components/Book1/WizardinOz17'
 import BOOK1WIZARDINOZ18 from '@/components/Book1/WizardinOz18'
 import BOOK1WIZARDINOZ19 from '@/components/Book1/WizardinOz19'
 import BOOK1WIZARDINOZ20 from '@/components/Book1/WizardinOz20'
 import BOOK1WIZARDINOZ21 from '@/components/Book1/WizardinOz21'
 import BOOK1WIZARDINOZ22 from '@/components/Book1/WizardinOz22'
 import BOOK1WIZARDINOZ23 from '@/components/Book1/WizardinOz23'
 import BOOK1PREVIEW from '@/components/Book1/Preview'
 import BOOK1PREVIEW_COVER from '@/components/Book1/Preview_cover'
 import BOOK1PREVIEW1 from '@/components/Book1/Preview1'
 import BOOK1PREVIEW2 from '@/components/Book1/Preview2'
 import BOOK1PREVIEW3 from '@/components/Book1/Preview3'
 import BOOK2COVER from '@/components/Book2/cover'
 import BOOK2ROADTOOZ from '@/components/Book2/RoadtoOz'
 import BOOK2ROADTOOZ1 from '@/components/Book2/RoadtoOz1'
 import BOOK2ROADTOOZ2 from '@/components/Book2/RoadtoOz2'
 import BOOK2ROADTOOZ3 from '@/components/Book2/RoadtoOz3'
 import BOOK2ROADTOOZ4 from '@/components/Book2/RoadtoOz4'
 import BOOK2ROADTOOZ5 from '@/components/Book2/RoadtoOz5'
 import BOOK2ROADTOOZ6 from '@/components/Book2/RoadtoOz6'
 import BOOK2ROADTOOZ7 from '@/components/Book2/RoadtoOz7'
 import BOOK2ROADTOOZ8 from '@/components/Book2/RoadtoOz8'
 import BOOK2ROADTOOZ9 from '@/components/Book2/RoadtoOz9'
 import BOOK2ROADTOOZ10 from '@/components/Book2/RoadtoOz10'
 import BOOK2ROADTOOZ11 from '@/components/Book2/RoadtoOz11'
 import BOOK2ROADTOOZ12 from '@/components/Book2/RoadtoOz12'
 import BOOK2ROADTOOZ13 from '@/components/Book2/RoadtoOz13'
 import BOOK2ROADTOOZ14 from '@/components/Book2/RoadtoOz14'
 import BOOK2ROADTOOZ15 from '@/components/Book2/RoadtoOz15'
 import BOOK2ROADTOOZ16 from '@/components/Book2/RoadtoOz16'
 import BOOK2ROADTOOZ17 from '@/components/Book2/RoadtoOz17'
 import BOOK2ROADTOOZ18 from '@/components/Book2/RoadtoOz18'
 import BOOK2ROADTOOZ19 from '@/components/Book2/RoadtoOz19'
 import BOOK2ROADTOOZ20 from '@/components/Book2/RoadtoOz20'
 import BOOK2ROADTOOZ21 from '@/components/Book2/RoadtoOz21'
 import BOOK2ROADTOOZ22 from '@/components/Book2/RoadtoOz22'
 import BOOK2ROADTOOZ23 from '@/components/Book2/RoadtoOz23'
 import BOOK2ROADTOOZ24 from '@/components/Book2/RoadtoOz24'
 import BOOK2ROADTOOZ25 from '@/components/Book2/RoadtoOz25'
 import BOOK3XHTML00_COVER from '@/components/Book3/xhtml/00_Cover'
 import BOOK3XHTML02_TITLE from '@/components/Book3/xhtml/02_Title'
 import BOOK3XHTML01_FM01 from '@/components/Book3/xhtml/01_Fm01'
 import BOOK3XHTML03_EDITION from '@/components/Book3/xhtml/03_Edition'
 import BOOK3XHTML04_PERHAPS from '@/components/Book3/xhtml/04_Perhaps'
 import BOOK3XHTML05_CHAPTER01 from '@/components/Book3/xhtml/05_Chapter01'
 import BOOK3XHTML06_CHAPTER02 from '@/components/Book3/xhtml/06_Chapter02'
 import BOOK3XHTML07_CHAPTER03 from '@/components/Book3/xhtml/07_Chapter03'
 import BOOK3XHTML08_CHAPTER04 from '@/components/Book3/xhtml/08_Chapter04'
 import BOOK3XHTML09_CHAPTER05 from '@/components/Book3/xhtml/09_Chapter05'
 import BOOK3XHTML10_CHAPTER06 from '@/components/Book3/xhtml/10_Chapter06'
 import BOOK3XHTML11_CHAPTER07 from '@/components/Book3/xhtml/11_Chapter07'
 import BOOK3XHTML12_CHAPTER08 from '@/components/Book3/xhtml/12_Chapter08'
 import BOOK3XHTML13_CHAPTER09 from '@/components/Book3/xhtml/13_Chapter09'
 import BOOK3XHTML14_CHAPTER10 from '@/components/Book3/xhtml/14_Chapter10'
 import BOOK3XHTML15_CHAPTER11 from '@/components/Book3/xhtml/15_Chapter11'
 import BOOK3XHTML16_CHAPTER12 from '@/components/Book3/xhtml/16_Chapter12'
 import BOOK3XHTML17_CHAPTER13 from '@/components/Book3/xhtml/17_Chapter13'
 import BOOK3XHTML18_CHAPTER14 from '@/components/Book3/xhtml/18_Chapter14'
 import BOOK3XHTML19_CHAPTER15 from '@/components/Book3/xhtml/19_Chapter15'
 import BOOK3XHTML20_CHAPTER16 from '@/components/Book3/xhtml/20_Chapter16'
 import BOOK3XHTML21_CHAPTER17 from '@/components/Book3/xhtml/21_Chapter17'
 import BOOK3XHTML22_CHAPTER18 from '@/components/Book3/xhtml/22_Chapter18'
 import BOOK3XHTML23_CHAPTER19 from '@/components/Book3/xhtml/23_Chapter19'
 import BOOK3XHTML24_CHAPTER20 from '@/components/Book3/xhtml/24_Chapter20'
 import BOOK3XHTML25_CHAPTER21 from '@/components/Book3/xhtml/25_Chapter21'
 import BOOK3XHTML26_CHAPTER22 from '@/components/Book3/xhtml/26_Chapter22'
 import BOOK3XHTML27_CHAPTER23 from '@/components/Book3/xhtml/27_Chapter23'
 import BOOK3XHTML28_CHAPTER24 from '@/components/Book3/xhtml/28_Chapter24'
 import BOOK3XHTML29_CHAPTER25 from '@/components/Book3/xhtml/29_Chapter25'
 import BOOK3XHTML30_CHAPTER26 from '@/components/Book3/xhtml/30_Chapter26'
 import BOOK3XHTML31_CHAPTER27 from '@/components/Book3/xhtml/31_Chapter27'
 import BOOK3XHTML32_CHAPTER28 from '@/components/Book3/xhtml/32_Chapter28'
 import BOOK3XHTML33_CHAPTER29 from '@/components/Book3/xhtml/33_Chapter29'
 import BOOK3XHTML34_CHAPTER30 from '@/components/Book3/xhtml/34_Chapter30'
 import COMONCOPYRIGHT from '@/components/Comon/copyright'
 import BAUM_OZ_BACKADAUBA from '@/components/Baum_Oz_Backad/auba'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/bundle_content",
 			"name" : "bundle_content",
 			"component" : BUNDLE_CONTENT
 		},
 		{
 			"path" : "/Book1/cover",
 			"name" : "Book1/cover",
 			"component" : BOOK1COVER
 		},
 		{
 			"path" : "/Book1/WizardinOz2",
 			"name" : "Book1/WizardinOz2",
 			"component" : BOOK1WIZARDINOZ2
 		},
 		{
 			"path" : "/Book1/Epigraph",
 			"name" : "Book1/Epigraph",
 			"component" : BOOK1EPIGRAPH
 		},
 		{
 			"path" : "/Book1/WizardinOz3",
 			"name" : "Book1/WizardinOz3",
 			"component" : BOOK1WIZARDINOZ3
 		},
 		{
 			"path" : "/Book1/WizardinOz4",
 			"name" : "Book1/WizardinOz4",
 			"component" : BOOK1WIZARDINOZ4
 		},
 		{
 			"path" : "/Book1/WizardinOz5",
 			"name" : "Book1/WizardinOz5",
 			"component" : BOOK1WIZARDINOZ5
 		},
 		{
 			"path" : "/Book1/WizardinOz6",
 			"name" : "Book1/WizardinOz6",
 			"component" : BOOK1WIZARDINOZ6
 		},
 		{
 			"path" : "/Book1/WizardinOz7",
 			"name" : "Book1/WizardinOz7",
 			"component" : BOOK1WIZARDINOZ7
 		},
 		{
 			"path" : "/Book1/WizardinOz8",
 			"name" : "Book1/WizardinOz8",
 			"component" : BOOK1WIZARDINOZ8
 		},
 		{
 			"path" : "/Book1/WizardinOz9",
 			"name" : "Book1/WizardinOz9",
 			"component" : BOOK1WIZARDINOZ9
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js